import history from '../history.js';

export const redirect = (route = '/') => {
  history.push(route);
};
